import { useMemo } from 'react'
import { useLocation } from 'react-router'

const getMetaData = (pathname: string, meta?: string) => {
  let title = `Valueize - ${meta}`

  if (pathname === `/dashboard`) {
    title = `Dashboard`
  } else if (pathname === `/dashboard/fundraising`) {
    title = `Fundraising`
  } else if (pathname === `/dashboard/report`) {
    title = `Report`
  } else if (pathname === `/dashboard/workspace`) {
    title = `Workspace`
  } else if (pathname.includes(`/revenues`)) {
    title = `Valueize - Revenues`
  } else if (pathname.includes(`/opex`)) {
    title = `Valueize - OPEX`
  } else if (pathname.includes(`/cogs`)) {
    title = `Valueize - COGS`
  } else if (pathname.includes(`/oic`)) {
    title = `Valueize - OIC`
  } else if (pathname.includes(`/cogs/totals`)) {
    title = `COGS Totals`
  } else if (pathname.includes(`/opex/totals`)) {
    title = `OPEX Totals`
  }

  return { title }
}

export const useMetaData = (meta?: string): { title: string } => {
  const { pathname } = useLocation()
  return useMemo(() => getMetaData(pathname, meta), [pathname, meta])
}
